module.exports = __webpack_public_path__ + "img/compact.cf4a24c7.png";